import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css'

const Footer = () => {
    return (
        <div className='footer'>

            <div className='footer-links-container'>
                <div>
                    <h3>Discover</h3>
                    <ul className='footer-links'>
                        <Link to='/all'><li>Shop all</li></Link>
                        <Link to='/birthday'><li>Birthday</li></Link>
                        <Link to='/wedding'><li>Wedding</li></Link>
                        <Link to='/engagement'><li>Engagement</li></Link>

                    </ul>
                </div>

                <div>
                    <h3>Company</h3>
                    <ul className='footer-links'>
                        <Link to='/about'><li>About Us</li></Link>

                    </ul>
                </div>

                <div>
                    <h3>Legal</h3>
                    <ul className='footer-links'>
                        <Link to='/terms-of-use' ><li>Terms of use</li></Link>
                        <Link to='/mobile-terms-of-service' ><li>Mobile Terms of Service</li></Link>
                        <Link to='/privacy-policy' ><li>Privacy Policy</li></Link>
                        <Link to='/cookie-policy' ><li>Cookie Policy</li></Link>
                    </ul>
                </div>

            </div>


            <div className="footer-copyright">
                <hr />
                <p>Bastard Cards © {new Date().getFullYear()} - All Rights Reserved.</p>
            </div>
        </div>
    )
}

export default Footer
